module.exports = __webpack_public_path__ + "img/开发.f43edff6.png";